<template>
  <div>
    <div
      @click="openModal = true"
      class="circular_small p-2 mx-auto bg-white rounded d-flex justify-content-between align-items-center circular"
      aling="center"
    >
      <p cols="12" class="circular_name text-primary h4">{{ name }}</p>
    </div>
    <modal-decisions
      v-if="isDecisions"
      v-model="openModal"
      :id="id"
    ></modal-decisions>
    <modal-circular
      :regulationLabel.sync="regulationLabel"
      v-else
      v-model="openModal"
      :id="id"
    ></modal-circular>
  </div>
</template>
<script>
import { BRow, BCol } from "bootstrap-vue";
import ModalCircular from "./ModalCircular.vue";
import ModalDecisions from "./ModalDecisions";
export default {
  props: ["name", "id", "isDecisions", "regulationLabel"],
  components: {
    BRow,
    BCol,
    ModalCircular,
    ModalDecisions,
  },
  data() {
    return {
      openModal: false,
    };
  },
};
</script>

<style scoped>
.circular_download {
  cursor: pointer;
  margin-top: 10px;
}
.circular {
  border: solid;
  border-color: rgb(14 87 150 / 0.1);
  border-width: 0.1rem;
  box-shadow: 0 20px 25px -5px rgb(14 87 150 / 0.1),
    0 8px 10px -6px rgb(14 87 150 / 0.1);
  max-width: 300px;
  height: 100px;
  cursor: pointer;
}
.circular_small {
  align-items: center;
}
@media (max-width: 630px) {
  .circular_name {
    font-size: 13px;
  }
  .circular_d {
    display: flex;
    justify-content: flex-end;
  }
  .circular_small {
    display: flex;
    justify-content: flex-start;
  }
}
</style>
